/**
 * @generated SignedSource<<26306092436d8001cc93ad3053d3313b>>
 * @relayHash ceddc8fd35d455d0ec9c8131440c1d1d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ba1d88df9c48f9ec78d00fe08fc0d6c6e19c7bc9cedad817a92edcca4b72ef88

import type { ConcreteRequest } from 'relay-runtime';
export type useContentRedactionsQuery$variables = {
  contentId: string;
};
export type useContentRedactionsQuery$data = {
  readonly singleContent: {
    readonly id: string | null;
    readonly redactionMetadataCount: number | null;
  } | null;
};
export type useContentRedactionsQuery = {
  response: useContentRedactionsQuery$data;
  variables: useContentRedactionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "redactionMetadataCount"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useContentRedactionsQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useContentRedactionsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ceddc8fd35d455d0ec9c8131440c1d1d",
    "id": "ba1d88df9c48f9ec78d00fe08fc0d6c6e19c7bc9cedad817a92edcca4b72ef88",
    "metadata": {},
    "name": "useContentRedactionsQuery",
    "operationKind": "query",
    "text": "query useContentRedactionsQuery($contentId:ID!){singleContent(id:$contentId){id,redactionMetadataCount}}"
  }
};
})();

(node as any).hash = "e90ee1af326d42d6929ca80f7d23161b";

export default node;
